<template>
  <div>
    <div class="filter-container">
      <el-row class="filter-top" type="flex" justify="end">
        <el-col :span="6">
          <slot name="toolbar-left">
            <span class="span-top-text">查询结果</span>
          </slot>
        </el-col>
        <el-col :span="18">
          <div style="text-align: right;">
            <div v-if="$permission.canWrite()">
              <el-button type="primary" @click="onAdd">添加</el-button>
              <el-button type="primary" @click="onSave" plain>保存</el-button>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-table border :data="data">
      <el-table-column label="期初单日期" prop="PeriodDate">
        <template slot-scope="{row}">
          <el-date-picker v-model="row.PeriodDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" @change="onChange(row)"></el-date-picker>
        </template>
      </el-table-column>
      <el-table-column label="账户名称" prop="AccountId">
        <template slot-scope="{row}">
          <el-select v-model="row.AccountId" @change="onChange(row)" filterable>
            <el-option v-for="(i,k) in Accounts" :key="k" :value="i.AccountId" :label="i.AccountName"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="期初余额" prop="Amount">
        <template slot-scope="{row}">
          <el-input v-model="row.Amount" @input="onChange(row)"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" align="center" width="80">
        <template slot-scope="{row,$index}">
          <el-button v-if="$permission.canWrite()" type="text" @click="onDelete(row,$index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>

export default {
  data() {
    return {
      api: require('@/api/rp/bankPeriodBeginning').default,
      account_api: require("@/api/ba/account").default,
      data: [],
      Accounts: []
    };
  },
  mounted() {
    if (!this.$permission.canPrice("/sy/initialize/initcashbanks")) {

    }
    this.account_api.list({ Status: 1 }).then(res => {
      if (res.Code == 0) {
        this.Accounts = res.Data;
      }
    })
  },
  methods: {
    reload() {
      this.api.list({}).then(res => {
        console.log("reload")
        if (res.Code == 0) {
          this.data = res.Data.map(x => ({ ...x, T: null }));
          if (this.data.length == 0) this.onAdd();
        }
      })
    },
    onChange(row) {
      console.log("change", row.T)
      if (row.T == null) row.T = 1;
    },
    onAdd() {
      this.data.push({ Id: 0, AccountId: null, Amount: null, PeriodDate: null, T: 0 });
    },
    onSave() {
      console.log("this.data", this.data);
      var data = this.data.filter(x => x.T != null);

      var periodDate = data.every(x => !!x.PeriodDate);
      if (!periodDate) {
        this.$message.warning("期初单日期不能为空");
        return;
      }
      var accountId = data.every(x => !!x.AccountId);
      if (!accountId) {
        this.$message.warning("账号不能为空");
        return;
      }
      var amount = data.every(x => !!x.Amount);
      if (!amount) {
        this.$message.warning("期初余额不能为空");
        return;
      }
      console.log("保存", data);

      var loading = this.$loading({
        lock: true,
        text: "正在保存...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      this.api.save(data).then((res) => {
        console.log("res", res);
        loading.close();
        if (res.Code == 0) {
          this.$message.success("保存成功");
          this.reload();
        } else {
          this.$message.error("保存失败");
        }
      });
    },
    onDelete(row, index) {
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        if (row.Id == 0) {
          this.data.splice(index, 1);
        } else {
          this.api.delete(row.Id).then((res) => {
            if (res.Code == 0) {
              this.$message.success("删除成功");
              this.reload();
            } else {
              this.$message.error("删除失败");
            }
          })
        }
      }).catch(() => { });
    },
  }
};
</script>
